// Build a linear graph from an ordered list of steps (used for copied steps that
// arrive without their own graph): each step exits to the next, no children/branches.
export const buildGraphFromSteps = (steps) => {
  const graph = {};
  steps.forEach((step, index) => {
    const nextStep = steps[index + 1];
    graph[step.id] = {
      exit: nextStep ? nextStep.id : null,
      child: null,
      branches: []
    };
  });
  return graph;
};
